import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { productTypesData } from '../data/productTypes';

const ProductLine = () => {
  const { language } = useLanguage();
  const t = productTypesData[language] || productTypesData.en || productTypesData.ru;

  return (
    <section className="pt-6 py-2 pb-6 bg-[#F5F5F0]" data-testid="product-line-section">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-[#061d36] text-center mb-12">{t.title}</h2>
        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {t.types.map((type, idx) => (
            <Link
              key={idx}
              to={`/products/${type.link}`}
              className="bg-[#F5F5F0] border-2 border-[#061d36] rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all group cursor-pointer block"
              data-testid={`home-product-card-${type.link}`}
            >
              {type.image && (
                <div className="px-6 pt-4 flex justify-center">
                  <img src={type.image} alt={type.name} className="h-48 w-auto object-contain" />
                </div>
              )}
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#061d36] mb-3 group-hover:text-[#8b4444] transition-colors">{type.name}</h3>
                <p className="text-[#061d36]/70 mb-4">{type.description}</p>
                <div className="space-y-2 mb-6">
                  {type.specs.map((spec, i) => (
                    <div key={i} className="flex items-center text-sm text-[#061d36]/60">
                      <CheckCircle2 className="w-4 h-4 text-[#061d36] mr-2 flex-shrink-0" />
                      <span className={spec.includes('Класс') || spec.includes('Class') ? 'font-bold text-[#061d36]' : ''}>
                        {spec}
                      </span>
                    </div>
                  ))}
                </div>
                <span className="inline-flex items-center justify-center px-6 py-3 rounded-full font-medium transition-all border-2 border-[#061d36] text-[#061d36] hover:bg-[#061d36] hover:text-white">
                  {t.more}
                  <ArrowRight className="w-4 h-4 ml-2" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductLine;
